import React, {useEffect, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
import PageHeader from '../components/layouts/PageHeader';
import PageFooter from '../components/layouts/PageFooter';
import IndexPage from './index';
import UserLoginPage from './user/login';
import UserRegisterPage from './user/register';
import UserProfilePage from './user/profile';
import {useMount} from 'react-use';
import {useAxios} from '../utils/AxiosProvider';
import {IUser} from '../hooks/apis/useUser';
import useAuth from '../utils/AuthContext';
import CommonApiErrorHandler from '../utils/HttpInstance';
import ManageSystemPage from './manage/system';
import CustomerError from '../components/CustomerError';
import ManagerUserList from './manage/user/list';
import ManageKnowledgeBankNewPage from './manage/knowledgeBank/new';
import ManageKnowledgeBankListPage from './manage/knowledgeBank/list';
import ManageKnowledgeBankEditPage from './manage/knowledgeBank/edit';
import ManageContestEditPage from './manage/contest/edit';
import ManageContestNewPage from './manage/contest/new';
import ManageContestListPage from './manage/contest/list';
import ManageContestNoticeListPage from './manage/contestNotice/list';
import ManageContestNoticeNewPage from './manage/contestNotice/new';
import ManageContestNoticeEditPage from './manage/contestNotice/edit';
import ContestDetailPage from './contest/[id]';
import ContestNoticeDetailPage from './contestNotice/[id]';
import KnowledgeTestHistoryPage from './knowledgeTest/[id]/history';
import KnowledgeTestResultPage from './knowledgeTest/[id]/result';
import KnowledgeTestDetailPage from './knowledgeTest/[id]';
import KnowledgeSubmissionSubmitPage from './knowledgeSubmission/[id]/submit';
import KnowledgeSubmissionResultPage from './knowledgeSubmission/[id]/result';
import ManageKnowledgeTestExportPage from './manage/knowledgeTest/exportReport';
import CollectionWorkUploadRecordPage from './collectionWork/[id]/uploadRecord';
import CollectionWorkMyRecordPage from './collectionWork/[id]/myRecords';
import CollectionWorkReviewPage from './collectionWork/[id]/review';

export default function AppPage() {
  const axios = useAxios();
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  useMount(() => {
    const token = localStorage.getItem('Application-Token');
    if (token) {
      setIsLoading(true);
      axios.instance
        .get<IUser>('/user/queryByToken', {
          params: {token: token},
        })
        .then(res => {
          auth.setToken(token);
          auth.setCurrentUser(res.data);
          setIsLoading(false);
        })
        .catch(e => {
          CommonApiErrorHandler(e);
          localStorage.removeItem('Application-Token');
          setIsLoading(false);
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  });
  if (isLoading) return <div>自动登录中</div>;
  return (
    <div className={'PC-Page'}>
      <PageHeader />
      <div className={'pageBody'}>
        <Switch>
          <Route path={'/'} component={IndexPage} exact />
          <Route path={'/user/login'} component={UserLoginPage} exact />
          <Route path={'/user/register'} component={UserRegisterPage} exact />
          <Route path={'/user/profile'} component={UserProfilePage} exact />
          <Route path={'/contest/:id'} component={ContestDetailPage} exact />
          <Route path={'/knowledgeTest/:id/history/:userId'} component={KnowledgeTestHistoryPage} exact />
          <Route path={'/knowledgeTest/:id/result/:userId'} component={KnowledgeTestResultPage} exact />
          <Route path={'/knowledgeTest/:id'} component={KnowledgeTestDetailPage} exact />
          <Route path={'/knowledgeSubmission/:id/submit'} component={KnowledgeSubmissionSubmitPage} exact />
          <Route path={'/knowledgeSubmission/:id/result'} component={KnowledgeSubmissionResultPage} exact />
          <Route path={'/collectionWork/:id/uploadRecord'} component={CollectionWorkUploadRecordPage} exact />
          <Route path={'/collectionWork/:id/myRecords'} component={CollectionWorkMyRecordPage} exact />
          <Route path={'/collectionWork/:id/review'} component={CollectionWorkReviewPage} exact />
          <Route path={'/contestNotice/:id'} component={ContestNoticeDetailPage} exact />
          <Route path={'/manage/system'} component={ManageSystemPage} exact />
          <Route path={'/manage/user/list'} component={ManagerUserList} exact />
          <Route path={'/manage/knowledgeBank/new'} component={ManageKnowledgeBankNewPage} exact />
          <Route path={'/manage/knowledgeBank/list'} component={ManageKnowledgeBankListPage} exact />
          <Route path={'/manage/knowledgeBank/edit/:id'} component={ManageKnowledgeBankEditPage} exact />
          <Route path={'/manage/knowledgeTest/exportReport/:id'} component={ManageKnowledgeTestExportPage} exact />
          <Route path={'/manage/contest/edit/:id'} component={ManageContestEditPage} exact />
          <Route path={'/manage/contest/new'} component={ManageContestNewPage} exact />
          <Route path={'/manage/contest/list'} component={ManageContestListPage} exact />
          <Route path={'/manage/contestNotice/list/:contestId'} component={ManageContestNoticeListPage} exact />
          <Route path={'/manage/contestNotice/new/:contestId'} component={ManageContestNoticeNewPage} exact />
          <Route path={'/manage/contestNotice/edit/:contestId/:id'} component={ManageContestNoticeEditPage} exact />
        </Switch>
      </div>
      <PageFooter />
    </div>
  );
}
